/**
 * The size, in px, the sidebar draws its Pushly icons at (aqe's `MenuIcon`, which defaults to 18 px). Larger than the
 * settings rail's, which keeps the default: the sidebar's icons are its only labels when it is collapsed.
 * `$pushly-icon-size` in `style/v2-app-menu.scss` matches it.
 */
export const SIDEBAR_ICON_SIZE = 22

/**
 * Map of module menu item component "key"s
 * to all associated UI path roots.
 *
 * The Domain root path resolves to the Settings module
 * so the association would be
 * {
 *   settings: [
 *     'domain'
 *   ],
 * }
 */
export const sidebarModulePathRootMap: Record<string, string[]> = {
    dashboard: ['root', 'dashboard'],
    notifications: ['notifications'],
    feeds: ['feeds'],
    appMessages: ['app-messages'],
    journeys: ['journeys'],
    catalogs: ['catalogs'],
    segments: ['segments'],
    prompts: ['prompts'],
    insights: ['insights'],
    settings: ['domains', 'organizations', 'settings'],
}
